"use strict";
exports.__esModule = true;
exports.entityFactory = void 0;
var normalizr_1 = require("normalizr");
var helpers_1 = require("../../helpers");
var fields_1 = require("../fields");
var processEntity = function (prismicDoc, logger) { return ({
    id: prismicDoc.id,
    lang: logger.required(fields_1.toLang(prismicDoc.lang, logger))
}); };
var entityFactory = function (type, next) {
    return new normalizr_1.schema.Entity(type, {}, {
        idAttribute: 'id',
        processStrategy: function (prismicDoc) {
            var _a = helpers_1.createLogger(), logs = _a.logs, logger = _a.logger;
            var entity = next(prismicDoc, processEntity(prismicDoc, logger), logger);
            if (logs) {
                entity.logs = logs;
                // eslint-disable-next-line no-console
                console.log('logs : ', JSON.stringify(logs, null, 2));
            }
            return entity;
        }
    });
};
exports.entityFactory = entityFactory;
//# sourceMappingURL=entity-factory.js.map